import React, { useContext, useRef } from "react";

import { SectionContainer } from "../../components/SectionContainer";
import { Headline } from "../../components/Headline";
import { Grid } from "../../components/Grid/Grid";
import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";

import GeneralPageContext from "../../templates/GeneralPageContext";
import ElementContext from "../../components/ElementContext";

import * as styles from "./component.module.less";
import { useMediaQuery } from "react-responsive";
import { useIsMobile } from "../../lib/hooks/mediaQueries";
import remoteAssetUrl from "../../lib/remote-asset-url";

export function HeroSplit({
    data: {
        background,
        ctaButtonLeft,
        ctaButtonRight,
        headlineLeft,
        headlineRight,
        mediaLeftOne,
        mediaLeftTwo,
        mediaLeftThree,
        mediaRightOne,
        mediaRightTwo,
        mediaRightThree,
        semanticOfHeadlineLeft,
        semanticOfHeadlineRight,
        subheadlineLeft,
        subheadlineRight
    }
}) {
    const isCustomMobile = useMediaQuery({ query: "(max-width: 600px)" });
    const isMax1024 = useMediaQuery({ query: "(max-width: 1024px)" });
    const isMin1025 = useMediaQuery({ query: "(min-width: 1025px)" });
    const isMin769 = useMediaQuery({ query: "(min-width: 769px" });
    const { isLightBg } = useContext(ElementContext);

    const isMobile = useIsMobile();

    const {
        // showBreadcrumb === true when
        layout: { showBreadcrumb }
    } = useContext(GeneralPageContext);

    return (
        <SectionContainer
            reducedWidth="never"
            background={background}
            sectionClass={styles.heroSplitSection}
        >
            <div className={styles.headerSplitContainer}>
                <div className={styles.splitContentLeft}>
                    {isCustomMobile ? (
                        <div className={styles.gridWrapper}>
                            <Grid
                                size={"m"}
                                className={styles.imageContainerLeft}
                            >
                                <img
                                    className={styles.image1}
                                    src={remoteAssetUrl(mediaLeftOne.url)}
                                    alt={mediaLeftOne.alt}
                                />
                                <img
                                    className={styles.image2}
                                    src={remoteAssetUrl(mediaLeftTwo.url)}
                                    alt={mediaLeftTwo.alt}
                                />
                                <img
                                    className={styles.image3}
                                    src={remoteAssetUrl(mediaLeftThree.url)}
                                    alt={mediaLeftThree.alt}
                                />
                            </Grid>
                        </div>
                    ) : (
                        <Grid
                            size={(isMax1024 && isMin769) ? "m" : (isMin1025) ? "l" : "m"}
                            className={styles.imageContainerLeft}
                        >
                            <img
                                className={styles.image1}
                                src={remoteAssetUrl(mediaLeftOne.url)}
                                alt={mediaLeftOne.alt}
                            />
                            <img
                                className={styles.image2}
                                src={remoteAssetUrl(mediaLeftTwo.url)}
                                alt={mediaLeftTwo.alt}
                            />
                            <img
                                className={styles.image3}
                                src={remoteAssetUrl(mediaLeftThree.url)}
                                alt={mediaLeftThree.alt}
                            />
                        </Grid>
                    )}
                    <Headline
                        semanticOfHeadline={semanticOfHeadlineLeft}
                        hasLightBackground={isLightBg}
                    >
                        {headlineLeft}
                    </Headline>
                    {!isMobile && (
                        <StructuredTextRenderer data={subheadlineLeft} />
                    )}
                    <StructuredTextRenderer
                        itemLinkType={"cta"}
                        data={ctaButtonLeft}
                        className={styles.heroSplitButton}
                    />
                </div>
                <div className={styles.splitContentRight}>
                    {isCustomMobile ? (
                        <div className={styles.gridWrapper}>
                            <Grid
                                size={"m"}
                                className={styles.imageContainerRight}
                            >
                                <img
                                    className={styles.image1}
                                    src={remoteAssetUrl(mediaRightOne.url)}
                                    alt={mediaRightOne.alt}
                                />
                                <img
                                    className={styles.image2}
                                    src={remoteAssetUrl(mediaRightTwo.url)}
                                    alt={mediaRightTwo.alt}
                                />
                                <img
                                    className={styles.image3}
                                    src={remoteAssetUrl(mediaRightThree.url)}
                                    alt={mediaRightThree.alt}
                                />
                            </Grid>
                        </div>
                    ) : (
                        <Grid
                            size={(isMax1024 && isMin769) ? "m" : (isMin1025) ? "l" : "m"}
                            className={styles.imageContainerRight}
                        >
                            <img
                                className={styles.image1}
                                src={remoteAssetUrl(mediaRightOne.url)}
                                alt={mediaRightOne.alt}
                            />
                            <img
                                className={styles.image2}
                                src={remoteAssetUrl(mediaRightTwo.url)}
                                alt={mediaRightTwo.alt}
                            />
                            <img
                                className={styles.image3}
                                src={remoteAssetUrl(mediaRightThree.url)}
                                alt={mediaRightThree.alt}
                            />
                        </Grid>
                    )}
                    <Headline
                        semanticOfHeadline={semanticOfHeadlineRight}
                        hasLightBackground={isLightBg}
                    >
                        {headlineRight}
                    </Headline>
                    {!isMobile && (
                        <StructuredTextRenderer data={subheadlineRight} />
                    )}
                    <StructuredTextRenderer
                        itemLinkType={"cta"}
                        data={ctaButtonRight}
                        className={styles.heroSplitButton}
                    />
                </div>
            </div>
        </SectionContainer>
    );
}
